import apiAnalytic from '@/api/analytic'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createAnalyticStart: '[create analytics] Create analytics start',
  createAnalyticSuccess: '[create analytics] Create analytics success',
  createAnalyticFailure: '[create analytics] Create analytics failure'
}

export const actionTypes = {
  createAnalytic: '[create analytics] Create analytics'
}

const mutations = {
  [mutationTypes.createAnalyticStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createAnalyticSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createAnalyticFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createAnalytic](context, {analytic}) {
    context.commit(mutationTypes.createAnalyticStart)
    return new Promise(resolve => {
      apiAnalytic
        .createAnalytics(analytic)
        .then(response => {
          context.commit(mutationTypes.createAnalyticSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createAnalyticFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
